export default "__VITE_PUBLIC_ASSET__2f37a44c__"